// @flow

import type { Middleware } from 'redux';
import logger from '../../logger';

const crashReporter: Middleware<*, *, *> = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    logger({
      store: store.getState(),
      error: err,
    });
    throw err;
  }
};

export default crashReporter;
